import * as React from 'react';
import * as _ from 'lodash';
import CheckBox from './../PageLayout/CheckBox';
import classNames from 'classnames';
import BlueDropDown from './../PageLayout/DropDowns/BlueDropDown';
import MultiLangInput from '../Generic/MultiLangInput';
export default function () {
    function repeatBi1(items, taxRegion, level, bi, biIndex) {
        return React.createElement('li', {
            'className': 'ui-breadcrumbs-link',
            'key': bi.id,
            'onClick': () => this.props.breadCrumbItemClick(bi)
        }, '\r\n        ', bi.name, '\r\n      ');
    }
    function onClick2(items, taxRegion, level) {
        this.showGroupDropDown(true);
    }
    function onBlur3(items, taxRegion, level) {
        this.showGroupDropDown(false);
    }
    function onClick4(items, taxRegion, level, group, groupIndex) {
        this.selectGroup(group);
    }
    function repeatGroup5(items, taxRegion, level, group, groupIndex) {
        return React.createElement('li', {
            'className': 'select-dropdown__list-item',
            'key': group,
            'onClick': onClick4.bind(this, items, taxRegion, level, group, groupIndex)
        }, '\r\n                ', group, '\r\n              ');
    }
    function onChecked6(items, taxRegion, level, item, itemIndex, checked) {
        this.props.updateItem(item, !checked, 'isEnabled');
    }
    function onChecked7(items, taxRegion, level, item, itemIndex, checked) {
        this.props.updateItem(item, !checked, 'isCustomEditableTax');
    }
    function repeatItem8(items, taxRegion, level, item, itemIndex) {
        return React.createElement('li', {
            'className': 'tax',
            'key': item.id || item.uid
        }, React.createElement('div', { 'className': 'tax-cell tax-cell--status' }, React.createElement(CheckBox, {
            'onChecked': onChecked6.bind(this, items, taxRegion, level, item, itemIndex),
            'checked': item.isEnabled,
            'text': true
        })), React.createElement('div', { 'className': 'tax-cell tax-cell--column' }, React.createElement('div', { 'className': 'tax-content' }, React.createElement('div', { 'className': 'tax-content__subtitle' }, item.taxRegionGroup), !item.isNameEditable ? React.createElement('div', {
            'className': 'tax-content__title',
            'onClick': () => this.makeItemEditable(item, 'isNameEditable'),
            'key': '3487'
        }, '\r\n                ', item.nameIntl['en-US'] || 'Enter ' + taxRegion.getCurrentGroupAtLevel(level), '\r\n              ') : null, item.isNameEditable ? React.createElement(MultiLangInput, {
            'translates': item.nameIntl,
            'type': 'gray',
            'placeholder': taxRegion.getCurrentGroupAtLevel(level),
            'onChange': nameIntl => this.props.updateItem(item, nameIntl, 'nameIntl'),
            'onBlur': () => this.props.updateItem(item, false, 'isNameEditable', false, false),
            'key': '3766'
        }) : null), React.createElement('div', { 'className': 'tax-content' }, React.createElement('div', { 'className': 'tax-content text-right' }, React.createElement('div', { 'className': 'tax-content__subtitle' }, 'material'), !item.isMaterialRateEditable ? React.createElement('div', {
            'className': 'tax-content__title',
            'onClick': () => this.makeItemEditable(item, 'isMaterialRateEditable'),
            'key': '4434'
        }, '\r\n                  ', item.materialRate === '' ? 'Enter Rate' : item.materialRate + '%', '\r\n                ') : null, item.isMaterialRateEditable ? React.createElement('input', {
            'type': 'text',
            'className': 'ui-input ui-input--gray tax-content__input',
            'value': item.materialRate || '',
            'id': 'isMaterialRateEditable_' + (item.id || item.uid),
            'onChange': e => this.props.updateItem(item, e.target.value, 'materialRate', true),
            'onBlur': () => this.props.updateItem(item, false, 'isMaterialRateEditable', false, false),
            'key': '4726'
        }) : null))), React.createElement('div', { 'className': 'tax-cell tax-cell--column' }, React.createElement('div', { 'className': 'tax-content' }, React.createElement('div', { 'className': 'tax-content' }, React.createElement('div', { 'className': 'tax-content__subtitle' }, 'labor'), !item.isLaborRateEditable ? React.createElement('div', {
            'className': 'tax-content__title',
            'onClick': () => this.makeItemEditable(item, 'isLaborRateEditable'),
            'key': '5495'
        }, '\r\n                  ', item.laborRate === '' ? 'Enter Rate' : item.laborRate + '%', '\r\n                ') : null, item.isLaborRateEditable ? React.createElement('input', {
            'type': 'text',
            'className': 'ui-input ui-input--gray tax-content__input',
            'value': item.laborRate || '',
            'id': 'isLaborRateEditable_' + (item.id || item.uid),
            'onChange': e => this.props.updateItem(item, e.target.value, 'laborRate', true),
            'onBlur': () => this.props.updateItem(item, false, 'isLaborRateEditable', false, false),
            'key': '5775'
        }) : null))), React.createElement('div', { 'className': 'tax-cell tax-cell--custom-input flex flex--center' }, React.createElement(CheckBox, {
            'onChecked': onChecked7.bind(this, items, taxRegion, level, item, itemIndex),
            'checked': item.isCustomEditableTax,
            'text': 'Show Input'
        })), React.createElement('div', { 'className': 'tax-cell tax-cell--remove' }, React.createElement('button', {
            'className': 'ui-icon-remove',
            'onClick': () => this.props.removeItem(item)
        })));
    }
    function scopeItemsTaxRegionLevel9() {
        var items = this.props.visibleItems.toJS();
        var taxRegion = this.props.taxRegion;
        var level = this.props.level;
        return React.createElement('div', { 'className': 'tax-setup' }, React.createElement('div', { 'className': 'tax-setup__breadcrumbs' }, React.createElement.apply(this, [
            'ul',
            { 'className': 'ui-breadcrumbs ui-breadcrumbs--dark' },
            _.map(this.props.breadCrumbItems, repeatBi1.bind(this, items, taxRegion, level))
        ])), React.createElement('div', { 'className': 'tax-setup__content tax-setup__content--single' }, React.createElement('div', { 'className': 'ts-block' }, React.createElement('div', { 'className': 'ts-block__top' }, React.createElement('div', { 'className': 'select select--active select--small select--blue tax-content__select' }, React.createElement('div', { 'className': 'select-value' }, React.createElement('span', { 'className': 'select-value__text' }, taxRegion.getCurrentGroupAtLevel(level)), React.createElement('button', {
            'className': 'select-value__button',
            'onClick': onClick2.bind(this, items, taxRegion, level)
        })), this.state.groupDropDownVisible ? React.createElement('div', {
            'className': 'select-dropdown',
            'tabIndex': '1',
            'onBlur': onBlur3.bind(this, items, taxRegion, level),
            'ref': ref => this.refGroupDropDown = ref,
            'key': '1281'
        }, React.createElement.apply(this, [
            'ul',
            { 'className': 'select-dropdown__list' },
            _.map(taxRegion.getGroupNamesAtLevel(level), repeatGroup5.bind(this, items, taxRegion, level))
        ])) : null), React.createElement('div', { 'className': 'ts-block__top-search' }, React.createElement('div', { 'className': 'ts-search' }, React.createElement('input', {
            'type': 'text',
            'className': 'ui-input ui-input--gray2 ts-search__input',
            'placeholder': 'Search',
            'value': this.props.searchText,
            'onChange': e => this.props.setSearchText(e.target.value)
        }), React.createElement('button', { 'className': 'ts-search__button' })))), React.createElement('div', { 'className': 'ts-block__sort' }, React.createElement('div', { 'className': classNames('ts-sort', 'ts-sort--enabled', 'ts-sort--left', 'ts-sort--asc') }, React.createElement('span', { 'className': 'ts-sort__text' }, 'Enabled')), React.createElement('div', { 'className': classNames('ts-sort', 'ts-sort--state', 'ts-sort--left', 'ts-sort--asc') }, React.createElement('span', { 'className': 'ts-sort__text' }, '\r\n                  State\r\n                ')), React.createElement('div', { 'className': classNames('ts-sort', 'ts-sort--rate', 'ts-sort--left', 'ts-sort--asc') }, React.createElement('span', { 'className': 'ts-sort__text' }, 'Tax Rate'))), React.createElement('div', { 'className': 'ts-block__button' }, React.createElement('button', {
            'className': 'ts-button',
            'onClick': this.props.addNewItem
        }, '+ Add New Tax Item')), React.createElement.apply(this, [
            'ul',
            { 'className': 'ts-block__list' },
            _.map(items, repeatItem8.bind(this, items, taxRegion, level))
        ]))));
    }
    return scopeItemsTaxRegionLevel9.apply(this, []);
}